import { Col, Row } from "react-bootstrap"

const FlakeBuild = () =>{
    
    return <> <h1>How to build Flake</h1>
      
    <p>All SMD parts come pre-soldered. All you need to do is solder the jacks and input pins:</p>
    <table>
        <tr>
        <th>Name </th>
        <th>Quantity </th>
        <th>Mandatory </th>
        <th>Source </th>
        <th>Details </th>
        </tr>
        <tr>
          <td>PJ302M Right Angle Mono Jack</td>
          <td>9</td>
          <td>Yes</td>
          <td>
          <a href="https://www.thonk.co.uk/shop/pj302m-jacks-x1/">Thonk</a><br/>
          <a href="https://www.taydaelectronics.com/pj-302m-3-5-mm-mono-phone-jack-3699.html">Tayda</a>
          </td>
        </tr>
        <tr>
          <td>Shrouded 2x5 pin header</td>
          <td>1</td>
          <td>Yes</td>
          <td>
            <a href = "https://www.thonk.co.uk/shop/eurorack-diy-essentials/">Thonk</a><br/>
            <a href = "https://www.taydaelectronics.com/10-pin-box-header-connector-2-54mm.html">Tayda</a>
          </td>
          <td>Can use unshrouded pins if you live fast and loose</td>
        </tr>
        
      </table>
      <br></br>
    <h2>Lets Go!</h2>
      <Col>
    <Row style={{}}>
    <Col style={{minWidth:"20rem"}}>
    <h4>Step 1:</h4>
    <p>Solder The shrouded headers, and Jacks - use the faceplate to keep them aligned</p>
    </Col> 
      <Col>
        <img src="/FlakeDIY/step1.jpg" style={{height:"30rem"}}></img>
      </Col>      
    </Row>
    <Row style={{margin:"4rem"}}></Row>

    <Row style={{}}>
    <Col style={{minWidth:"20rem"}}>
    <h4>Step 2:</h4>
    <p>If you don't have the connecting cable then you can make one youself</p>
    </Col> 
      <Col>
        <img src="/FlakeDIY/cable.jpg" style={{height:"30rem"}}></img>
      </Col>      
    </Row>
    <Row style={{margin:"4rem"}}></Row>

    <Row style={{}}>
    <Col style={{minWidth:"20rem"}}>
    <h4>Step 3:</h4>
    <p>Connect the expander to the main module like so</p>
    <p>Done.</p>
    </Col> 
      <Col>
        <img src="/FlakeDIY/back.jpg" style={{height:"30rem"}}></img>
      </Col>      
    </Row>
    <Row style={{margin:"4rem"}}></Row>
    </Col>

</>
}

export default FlakeBuild